<template>
  <section class="evento-page">
    <div class="banner-eventos banner wow animate__animated animate__fadeInRightBig">
      <h1>Eventos</h1>
    </div>
    <div class="container py-5">
      <p class="wow animate__animated animate__fadeInLeftBig">Aqui na Fresto temos uma grande variedade de shows!</p>

      <h3 class="txt-lemon-green mb-4 wow animate__animated animate__fadeInLeftBig"><b>Confira nossa agenda:</b></h3>

      <div class="row wow animate__animated animate__fadeInRightBig">
        <div class="col-sm-12 col-md-6 col-lg-6">
          <div class="row row-eventos">
            <div class="col-sm-12 col-md-4 col-lg-4 px-0">
              <img src="../assets/img/foto-eventos-test.webp" class="w-100" alt="">
            </div>
            <div class="col-sm-12 col-md-8 col-lg-8 px-4">
              <p><b>Thais Piza</b></p>
              <p>Horário: 19h</p>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-md-6 col-lg-6">
          <div class="row row-eventos">
            <div class="col-sm-12 col-md-4 col-lg-4 px-0">
              <img src="../assets/img/foto-eventos-test.webp" class="w-100" alt="">
            </div>
            <div class="col-sm-12 col-md-8 col-lg-8 px-4">
              <p><b>Thais Piza</b></p>
              <p>Horário: 19h</p>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-md-6 col-lg-6">
          <div class="row row-eventos">
            <div class="col-sm-12 col-md-4 col-lg-4 px-0">
              <img src="../assets/img/foto-eventos-test.webp" class="w-100" alt="">
            </div>
            <div class="col-sm-12 col-md-8 col-lg-8 px-4">
              <p><b>Thais Piza</b></p>
              <p>Horário: 19h</p>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-md-6 col-lg-6">
          <div class="row row-eventos">
            <div class="col-sm-12 col-md-4 col-lg-4 px-0">
              <img src="../assets/img/foto-eventos-test.webp" class="w-100" alt="">
            </div>
            <div class="col-sm-12 col-md-8 col-lg-8 px-4">
              <p><b>Thais Piza</b></p>
              <p>Horário: 19h</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
export default {
  name: 'EventosPage',
};
</script>

<style scoped>
/* estilos específicos do componente */
</style>